import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserInfoService from '../../services/api/userInfoService';
import AppSecureStorage from '../../services/storage/secureStorage';
import { message } from 'antd'
import AuthService from '../../services/api/authService';
// import { unauthorizedError } from '../../utils/helpers';
import { setUserProfile, setUserType } from '../Global/globalSlice';
import { get_profile_percentage } from '../Jobseeker/jobseekerSlice';
import { get_all_Subscriptions_jobseeker, get_latest_Subscriptions_jobseeker, setJobseekerId, setOwnSkillsData } from './UserSlice';

const userInfo = new UserInfoService();
const storage = new AppSecureStorage();
const auth = new AuthService();

export const get_jobseeker = createAsyncThunk(
  "userInfo/get_jobseeker",
  async (navigate, { dispatch }) => {
    dispatch(setGetDetailsLoad(true))
    try {
      const response = await userInfo.Get_Jobseeker()
      const { data } = response;
      dispatch(setGetDetailsLoad(false))
      dispatch(setUserType('employee'))
      dispatch(setUserProfile(data))
      dispatch(setJobseekerId(data?._id))
      dispatch(setOwnSkillsData(data?.ownSkills))
      dispatch(get_all_Subscriptions_jobseeker(navigate))
      dispatch(get_latest_Subscriptions_jobseeker(navigate))
      return response.data
    } catch (error) {
      dispatch(setGetDetailsLoad(false))
      // if (error?.response && [401, 403, 419, 440].includes(error.response.status)) {
      //   dispatch(setUserProfile({}));
      //   unauthorizedError(navigate);
      // }
      // else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        error?.response?.data?.forEach((err) => {
          message.error(`${err.msg} of ${err?.path}`);
        });
      // }
    }
  }
);


export const get_applied_jobs = createAsyncThunk(
  "userInfo/get_applied_jobs",
  async (navigate, { dispatch }) => {
    dispatch(setAppliedJobLoad(true))
    try {
      const response = await userInfo.Get_applied_jobs()
      const { data } = response;
      dispatch(setAppliedJobLoad(false))
      dispatch(setAppliedJob(data))
      return response.data
    } catch (error) {
      dispatch(setAppliedJobLoad(false))
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        error?.response?.data?.forEach((err) => {
          message.error(`${err.msg} of ${err?.path}`);
        });
      // }
    }
  }
);

export const get_jobseeker_skills = createAsyncThunk(
  "userInfo/get_jobseeker_skills",
  async (navigate, { dispatch }) => {
    dispatch(setSkillLoad(true))
    try {
      const response = await userInfo.Get_Jobseeker_Skills()
      const { data } = response;
      dispatch(setEmployeeSkills(data))
      dispatch(setSkillLoad(false))
      return response.data
    } catch (error) {
      dispatch(setSkillLoad(false))
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        dispatch(setSkillLoad(false))
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        const [{ msg }] = error.response.data;
        message.error(msg);
      // }
    }
  }
);

export const update_jobseeker = createAsyncThunk(
  "userInfo/update_jobseeker",
  async ({ body, navigate }, { dispatch }) => {
    try {
      const response = await userInfo.Update_Jobseeker(body)
      const { data } = response;
      dispatch(get_jobseeker(navigate))
      dispatch(setUserProfile(data))
      storage.setItem('userUpdation', data)
      message.success(response.data.msg)
      dispatch(get_profile_percentage(navigate))
      return response.data
    } catch (error) {
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        error?.response?.data?.forEach((err) => {
          message.error(`${err.msg} of ${err?.path}`);
        });
      // }
      return error
    }
  }
);

export const genrate_login_otp_user_Info = createAsyncThunk(
  "userInfo/genrate_login_otp",
  async ({ body, navigate, isMobile, isEmail }, { dispatch }) => {
    dispatch(setIsGenerateOTPLoad(true))
    try {
      const response = await auth.GenerateOTP(body)
      const { data } = response;
      message.success(data.message)
      dispatch(setIsGenerateOTPLoad(false))
      if (isEmail) {
        dispatch(setverifyType(''))
        dispatch(setIsEmailVerify(true))
      }
      if (isMobile) {
        dispatch(setverifyType(''))
        dispatch(setIsMobileVerify(true))
      }
      return response.data
    } catch (error) {
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        dispatch(setverifyType(''))
        dispatch(setIsGenerateOTPLoad(false))
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        error?.response?.data?.forEach((err) => {
          message.error(`${err.msg} of ${err?.path}`);
        });
      // }
    }
  }
);

export const verify_otp__user_Info = createAsyncThunk(
  "auth/verify_otp",
  async ({ body, navigate }, { dispatch }) => {
    dispatch(setIsOTPSubmit(true))
    try {
      const response = await auth.VerifyOTP(body)
      const { data } = response;
      message.success(data.message)
      dispatch(get_jobseeker(navigate))
      dispatch(setIsOTPSubmit(false))
      dispatch(setIsEmailVerify(false))
      dispatch(setIsMobileVerify(false))
      return response.data
    } catch (error) {
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        dispatch(setIsOTPSubmit(false))
        const [{ msg }] = error.response.data
        message.error(msg)
      }
    // }
  }
);


export const get_tickets = createAsyncThunk(
  "userInfo/get_ticket",
  async ({ body, navigate }, { dispatch }) => {
    dispatch(setTicketLoad(true))
    try {
      const response = await userInfo.Get_Tickets_data()
      const { data } = response;
      dispatch(setTicketLoad(false))
      dispatch(setTicketList(data))
      return response.data
    } catch (error) {
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        error?.response?.data?.message && message.error(error?.response?.data?.message)
      }
    // }
  }
);

export const create_tickets = createAsyncThunk(
  "userInfo/create_ticket",
  async ({ body, navigate }, { dispatch }) => {
    dispatch(setTicketLoad(true))
    try {
      const response = await userInfo.Create_jobseeker_tickets(body)
      const { data } = response;
      message.success("Ticket created successfully")
      dispatch(setTicketLoad(false))
      //  dispatch()
      return response.data
    } catch (error) {
      // if (error?.response && error?.response?.status === 401) {
      //   dispatch(setUserProfile({}))
      //   unauthorizedError(navigate)
      // } else {
        error?.response?.data?.error && message.error(error?.response?.data?.error)
        dispatch(setTicketLoad(false))
        const [{ msg }] = error.response.data
        message.error(msg)
      }
    // }
  }
);




const initialState = {
  isLoginPage: true,
  loading: true,
  isProfileEdit: false,
  isEmailVerify: false,
  isMobileVerify: false,
  verifyLoading: false,
  emailVerified: false,
  mobileVerified: false,
  isGenerateOTPLoad: false,
  verifyType: '',
  isOtpSubmit: false,
  employeeSkills: [],
  isLanguageAdd: false,
  getDetailsLoad: false,
  appliedLoad: false,
  allAppliedJobs: {},
  ticketList: [],
  ticketLoad: false,
  skillLoad: false
};


const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setIsEditProfile: (state, action) => {
      state.isProfileEdit = action.payload
    },
    setIsMobileVerify: (state, action) => {
      state.isMobileVerify = action.payload
    },
    setIsEmailVerify: (state, action) => {
      state.isEmailVerify = action.payload
    },
    setVerifyLoading: (state, action) => {
      state.verifyLoading = action.payload
    },
    setIsGenerateOTPLoad: (state, action) => {
      state.isGenerateOTPLoad = action.payload
    },
    setverifyType: (state, action) => {
      state.verifyType = action.payload
    },
    setIsOTPSubmit: (state, action) => {
      state.isOtpSubmit = action.payload
    },
    setEmployeeSkills: (state, action) => {
      state.employeeSkills = action.payload
    },
    setIsLanguageAdd: (state, action) => {
      state.isLanguageAdd = action.payload
    },
    setGetDetailsLoad: (state, action) => {
      state.getDetailsLoad = action.payload
    },
    setAppliedJob: (state, action) => {
      state.allAppliedJobs = action.payload
    },
    setAppliedJobLoad: (state, action) => {
      state.appliedLoad = action.payload
    },
    setTicketList: (state, action) => {
      state.ticketList = action.payload
    },
    setTicketLoad: (state, action) => {
      state.ticketLoad = action.payload
    },
    setSkillLoad: (state, action) => {
      state.skillLoad = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(update_jobseeker.pending, (state, action) => {
      state.loading = true;
    })
      .addCase(update_jobseeker.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(update_jobseeker.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(genrate_login_otp_user_Info.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(genrate_login_otp_user_Info.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(genrate_login_otp_user_Info.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(verify_otp__user_Info.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(verify_otp__user_Info.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(verify_otp__user_Info.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(get_jobseeker_skills.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(get_jobseeker_skills.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
      })
      .addCase(get_jobseeker_skills.rejected, (state, action) => {
        state.loading = false;
      })
  }
});

export const { setIsEditProfile, setIsEmailVerify, setIsMobileVerify,
  setVerifyLoading, setIsGenerateOTPLoad, setverifyType, setIsOTPSubmit, setEmployeeSkills, setGetDetailsLoad,
  setIsLanguageAdd, setAppliedJob, setAppliedJobLoad, setTicketList, setTicketLoad, setSkillLoad } = userInfoSlice.actions;
export default userInfoSlice.reducer;
